import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { Redirect } from "react-router-dom";
import withStyles from '@material-ui/core/styles/withStyles'
import GridContainer from 'components/Grid/GridContainer.jsx'
import GridItem from 'components/Grid/GridItem.jsx'
import CircularProgress from '@material-ui/core/CircularProgress'
import RequestForm from 'views/Forms/RequestForm'
import { Query } from 'react-apollo'
import { GET_OPE_FOR_NEW_PART, GET_OPE_FOR_EDIT_PART } from 'api/query.js'
import { getUserToken } from 'services/utils'
import SnackbarContent from '@material-ui/core/SnackbarContent'
import translation from '../../translation/translate'
import style from "assets/css/style.jsx"
import pricingPageStyle from 'assets/jss/material-dashboard-pro-react/views/pricingPageStyle.jsx'
import validationFormsStyle from 'assets/jss/material-dashboard-pro-react/views/validationFormsStyle.jsx'
import extendedFormsStyle from 'assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.jsx'
import customInputStyle from 'assets/jss/material-dashboard-pro-react/components/customInputStyle.jsx'
import {warningColor} from "assets/jss/material-dashboard-pro-react.jsx";

const styles = require(`../../assets/css/style.jsx`).default;

const client = process.env.REACT_APP_CLIENT

const styleNewRequest = {
  ...pricingPageStyle,
  ...validationFormsStyle,
  ...extendedFormsStyle,
  labelRootError: customInputStyle.labelRootError,
  removeButton: {
    float: 'right',
    bottom: '31px'
  },
  icons: {
    width: "17px",
    height: "17px",
    margin: '-2px 4px 0px!important'
  },
  limitTitle: {
    color: warningColor,
    textAlign: "center"
  },
  snackbar: {
    margin: "150px",
    backgroundColor: "#d32f2f",
  },
}

class ConsumerNewRequestPage extends React.Component {

  render() {

    const { classes, match: {params}, history } = this.props;
    const token = getUserToken()
    const user_id = token.id
    const graph_query = params.part_id !== undefined ? GET_OPE_FOR_EDIT_PART : GET_OPE_FOR_NEW_PART
    return (
      <div className={classes.content}>
        <div className={classes.container}>
          <Query
            query={graph_query}
            variables={{
              ope_id: `/api/operations/${params.ope_id}`,
              counter_id: `/api/customer_operations/customer=${user_id};operation=${params.ope_id}`,
              sign_id: `/api/signatures/customer=${user_id};operation=${params.ope_id}`,
              user_id: `/api/${token.type}/${user_id}`,
              part_id: `/api/participations/${params.part_id}`,
              is_groups: token.type === 'groupements'
            }}
            fetchPolicy="network-only"
            >
            {({ data, error, loading }) => {
              if (loading) return <GridContainer justify='center'><CircularProgress className={classes.title} color="secondary"/></GridContainer>
              if (error) return <GridContainer justify='center'><SnackbarContent className={classes.snackbar} message={'Problème, veuillez réessayer ulterieurement.'}/></GridContainer>
              if (null === data.operation) {
                return <Redirect from='' to='/' />
              }

              const has_limit = data.counter !== null && data.counter.partMax !== null
              const part_limit = has_limit ? data.counter.partMax - data.counter.counter : null

              return <Fragment>
                  <GridContainer justify='center'>
                    <GridItem xs={12} sm={12} md={12}>
                      <h1 style={styles.titleWhite}>{data.old_part === undefined ? translation[client].home_title_new : `Modification demande N° ${data.old_part.code}`}</h1>
                      {data.old_part === undefined && part_limit !== null && part_limit > 0 && <h3 style={styles.limitTitle}>Nombre de participations autorisées : <strong>{part_limit}</strong></h3>}
                      {data.old_part === undefined && part_limit !== null && part_limit <= 0 && <h3 style={styles.limitTitle}>Vous avez atteint le maximum de participation</h3>}

                      <div style={styles.opLimitParticipation}>
                        <p style={styles.opLimitPartText}><span style={styles.opLimitPartSpan}><i class="fas fa-exclamation-triangle"></i> Attention :</span> Vous ne pouvez participer qu'une seule fois à une opération. Merci de vérifier que votre listing comprend la totalité des ventes liée à l'opération. Votre participation ne pourra pas être modifiée par la suite.</p>
                      </div>
                    </GridItem>
                  </GridContainer>
                  {(part_limit === null || part_limit > 0 || data.old_part) && <RequestForm classes={classes} match_params={params} history={history} data={data} part_limit={part_limit}/>}
                </Fragment>
            }}
            </Query>
        </div>
      </div>
    );
  }
}

ConsumerNewRequestPage.propTypes = {
  classes: PropTypes.object.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired
};

export default withStyles(style, styleNewRequest)(ConsumerNewRequestPage);



// WEBPACK FOOTER //
// ./src/views/Pages/ConsumerNewRequestPage.jsx